(function(){
  var root = document.documentElement;
  var header = null;
  var zones = [];
  var ticking = false;
  var lastState = null;
  var primarySelectors = [
    '[data-ss-header-blend-zone]',
    '.page-about-image',
    '.section-visual-frame',
    '.section-visual',
    '.collection-random-image',
    '.collection-hero__image-container',
    '.collection-hero__image-wrapper',
    '.article-detail-image',
    '.article-template__hero-container',
    '.product-detail-media',
    '.product-detail-gallery',
    '.main-visual',
    '.visual-display',
    '.banner__media',
    '.banner',
    '.slideshow__media',
    '.slideshow',
    '.image-banner'
  ];
  function isVisible(el){
    if(!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && el.offsetWidth > 0 && el.offsetHeight > 0;
  }
  function usableRect(el){
    if(!isVisible(el)) return null;
    var rect = el.getBoundingClientRect();
    if(rect.width < 80 || rect.height < 80) return null;
    return rect;
  }
  function docTop(el){
    var rect = el.getBoundingClientRect();
    return rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
  }
  function isNearFirstView(el){
    var top = docTop(el);
    var limit = Math.max(window.innerHeight * 1.15, 720);
    return top < limit;
  }
  function findPrimaryZone(){
    for(var i=0;i<primarySelectors.length;i++){
      var selector = primarySelectors[i];
      var candidates = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function(el){
        return usableRect(el) && isNearFirstView(el) && !el.closest('footer') && !el.closest('.footer');
      });
      if(candidates.length){
        candidates.sort(function(a,b){ return docTop(a) - docTop(b); });
        return candidates[0];
      }
    }
    return null;
  }
  function collectZones(){
    header = document.querySelector('.section-header .header-wrapper') || document.querySelector('.header-wrapper');
    var primary = findPrimaryZone();
    zones = primary ? [primary] : [];
    update();
  }
  function pointInsideZone(x,y,rect){
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }
  function shouldBlend(){
    if(!header || !isVisible(header)) return false;
    if(!zones.length) return false;
    if(root.hasAttribute('data-menu-open')) return false;
    if(document.body && document.body.classList.contains('overflow-hidden')) return false;
    var h = header.getBoundingClientRect();
    if(h.bottom <= 0 || h.top >= window.innerHeight) return false;
    var probeY = h.top + (h.height * 0.65);
    var probeXs = [window.innerWidth * 0.18, window.innerWidth * 0.5, window.innerWidth * 0.82];
    for(var i=0;i<zones.length;i++){
      var z = zones[i];
      if(!isVisible(z)) continue;
      var r = z.getBoundingClientRect();
      if(r.bottom < -20 || r.top > window.innerHeight + 20) continue;
      for(var j=0;j<probeXs.length;j++){
        if(pointInsideZone(probeXs[j], probeY, r)) return true;
      }
    }
    return false;
  }
  function apply(state){
    if(state === lastState) return;
    lastState = state;
    root.classList.toggle('ss-header-on-visual', state);
  }
  function update(){
    ticking = false;
    apply(shouldBlend());
  }
  function requestUpdate(){
    if(ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }
  function init(){
    collectZones();
    window.addEventListener('scroll', requestUpdate, {passive:true});
    window.addEventListener('resize', function(){ collectZones(); }, {passive:true});
    document.addEventListener('shopify:section:load', collectZones);
    document.addEventListener('shopify:section:unload', collectZones);
    var observer = new MutationObserver(function(){ requestUpdate(); });
    observer.observe(root, {attributes:true, attributeFilter:['data-menu-open','class']});
    setTimeout(collectZones, 500);
    setTimeout(collectZones, 1500);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
